import ContactUsForm from "../../components/landing/ContactUsForm";
import { format } from "date-fns";
import Link from "next/link";
import { UserInfo } from "datamynt-ui-library";
import { setArticlePage } from "../../contexts/Landing/actions";
import { useContext, useEffect } from "react";
import { LandingContext } from "../../contexts/Landing";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton
} from "react-share";

function Press({ item, children }) {
  const {
    state: { articlePage },
    dispatch
  } = useContext(LandingContext);

  useEffect(() => {
    setArticlePage(dispatch, true);
  }, [dispatch, articlePage]);

  return (
    <div className={"w-full h-full flex items-center flex-col justify-center"}>
      <div className={"w-full lg:w-4/5 space-y-4 p-8"}>
        <Link href={"/press"}>
          <a className={"text-gray-50 text-sm"}>{"< Datamynt Blog"}</a>
        </Link>
        <h5>{item["heading"]}</h5>
        <div className={"w-full flex justify-between md:-ml-4"}>
          <UserInfo
            width={40}
            height={40}
            name={item["author"]}
            mail={format(new Date(item["date"]), "MMMM dd, yyyy")}
          />
          <ul className={"flex space-x-4 items-center  md:-ml-4"}>
            <li>Share on:</li>
            <li>
              <FacebookShareButton
                url={item["link"]}
                className={"flex items-center cursor-pointer"}
              >
                <svg
                  width="30"
                  height="30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
                    fill="#3D8ECD"
                  />
                  <path
                    d="M19.962 4.451h-3.36c-2.003 0-4.229.846-4.229 3.739v3.071H10.06v3.672h2.38v10.594h4.385V14.844h2.893l.267-3.627h-3.227v-2.07c0-1.135 1.202-1.09 1.269-1.09h1.958l-.022-3.606Z"
                    fill="#fff"
                  />
                </svg>
              </FacebookShareButton>
            </li>
            <li>
              <LinkedinShareButton
                url={item["link"]}
                className={"flex items-center cursor-pointer"}
              >
                <svg
                  width="30"
                  height="30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
                    fill="#3D8ECD"
                  />
                  <path
                    d="M10.348 23.168V12.129H6.676v11.039h3.672ZM8.5 10.638c1.268 0 2.07-.846 2.07-1.914-.023-1.09-.802-1.914-2.048-1.914s-2.07.823-2.07 1.914c0 1.068.801 1.914 2.025 1.914h.023Zm3.872 12.53h3.672v-6.165c0-.334.022-.668.111-.89.267-.668.868-1.336 1.892-1.336 1.335 0 1.847 1.002 1.847 2.493v5.898h3.672v-6.32c0-3.384-1.802-4.964-4.228-4.964-1.98 0-2.849 1.113-3.338 1.87h.022V12.15h-3.65c.045 1.024 0 11.017 0 11.017Z"
                    fill="#fff"
                  />
                </svg>
              </LinkedinShareButton>
            </li>
            <li>
              <TelegramShareButton
                url={item["link"]}
                className={"flex items-center cursor-pointer"}
              >
                <svg
                  width="30"
                  height="30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 15c0 8.279-6.699 15-15 15-8.279 0-15-6.699-15-15C0 6.721 6.699 0 15 0s15 6.699 15 15Z"
                    fill="#3D8ECD"
                  />
                  <path
                    d="M12.26 21.854c-.489 0-.4-.178-.578-.645l-1.424-4.696 8.835-5.52 1.046.268-.868 2.359-7.01 8.234Z"
                    fill="#B3B3B3"
                  />
                  <path
                    d="M12.262 21.855c.378 0 .534-.178.756-.379.334-.311 4.496-4.362 4.496-4.362l-2.56-.623-2.38 1.491-.312 3.74v.133Z"
                    fill="gray"
                  />
                  <path
                    d="m12.507 18.049 6.054 4.451c.69.378 1.18.178 1.357-.645l2.47-11.595c.245-1.002-.378-1.47-1.045-1.158L6.899 14.666c-.98.4-.98.957-.178 1.18l3.717 1.157 8.59-5.408c.4-.245.779-.111.467.156l-6.988 6.298Z"
                    fill="#fff"
                  />
                </svg>
              </TelegramShareButton>
            </li>
            <li>
              <TwitterShareButton
                url={item["link"]}
                className={"flex items-center cursor-pointer"}
              >
                <svg
                  width="30"
                  height="30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
                    fill="#3D8ECD"
                  />
                  <path
                    d="M24.367 10.771a7.293 7.293 0 0 1-1.958.534 3.33 3.33 0 0 0 1.49-1.891 6.88 6.88 0 0 1-2.158.823 3.392 3.392 0 0 0-2.492-1.068c-1.892 0-3.428 1.536-3.428 3.405 0 .267.022.534.09.779a9.662 9.662 0 0 1-7.033-3.56 3.467 3.467 0 0 0-.468 1.713c0 1.18.601 2.225 1.514 2.848a3.691 3.691 0 0 1-1.558-.422v.044c0 1.647 1.18 3.027 2.737 3.36-.29.09-.579.112-.89.112-.223 0-.445-.022-.646-.067a3.453 3.453 0 0 0 3.183 2.381 6.924 6.924 0 0 1-4.25 1.47c-.268 0-.557-.023-.824-.045a9.605 9.605 0 0 0 5.23 1.535c6.276 0 9.725-5.207 9.725-9.725v-.445a6.946 6.946 0 0 0 1.736-1.78Z"
                    fill="#fff"
                  />
                </svg>
              </TwitterShareButton>
            </li>
          </ul>
        </div>
        <div className={"rounded-lg shadow overflow-hidden"}>
          <img className={"w-full"} src={item["img"]} alt={"press"} />
        </div>
        {item["link"] && item["linkSource"] && (
          <p className={"text-gray-50 text-xs font-semibold"}>
            Source{" "}
            <Link href={item["link"]}>
              <a
                key="1"
                target="_blank"
                rel="noreferrer"
                className="text-primary underline"
              >
                {item["linkSource"]}
              </a>
            </Link>
          </p>
        )}
        {children}
      </div>
      <div className="w-full h-full">
        <div className="px-8 bg-wrapper text-white flex flex-col items-center justify-center space-y-12 pt-10 pb-10">
          <ContactUsForm />
        </div>
      </div>
    </div>
  );
}

export default Press;
